import { useQuery } from '@apollo/client';
import logoIcone from 'assets/images/logo-branca-simbolo.svg';
import logoText from 'assets/images/logo-branca-texto.svg';
import BotaoMenu from 'components/BotaoMenu';
import BotaoSubMenu from 'components/BotaoMenu/SubMenu';
import Icone from 'components/Icone';
import SelectUnidadeEUsuario from 'components/SelectUnidadeEUsuario';
import { GRAPHQL_RECUPERAR_RESOURCES_POR_USUARIO } from 'gql/resources';
import React, { FC, useCallback, useEffect, useState } from 'react';
import {
    ContainerCard,
    Logo,
    ToggleMenu,
    WarpLogo,
    WarpLogoMenu,
    WrapHeader,
} from './styl';

const useMenu = () => {
    const [menu, setMenu] = useState<HTMLInputElement>(null);

    const handleClickSubMenu = useCallback(
        inputDom => {
            if (menu !== null) {
                menu.checked = false;
            }
            setMenu(inputDom);
        },
        [menu],
    );
    const closeSubmenu = useCallback(
        event => {
            if (
                event.target &&
                event.target.parentNode &&
                event.target.parentNode.classList &&
                event.target.parentNode.classList.contains &&
                !event.target.parentNode.classList.contains('group')
            ) {
                handleClickSubMenu(null);
            }
        },
        [handleClickSubMenu],
    );
    useEffect(() => {
        document.addEventListener('click', closeSubmenu);
        return () => {
            document.removeEventListener('click', closeSubmenu);
        };
    }, [closeSubmenu]);
    const renderMenu = (botao, indice) => (
        <BotaoMenu
            {...botao}
            zIndex={100 - indice}
            indice={indice}
            key={`${botao.id}-${indice}`}
        />
    );
    const renderSubmenu = (botao, indice) => (
        <BotaoSubMenu
            zIndex={70 - indice}
            onClickSubMenu={handleClickSubMenu}
            {...botao}
            indice={indice}
            key={`${botao.id}-${indice}`}>
            {botao.resourceFilhos.length > 1 && (
                <ContainerCard>
                    {botao.resourceFilhos.map(renderMenu)}
                </ContainerCard>
            )}
        </BotaoSubMenu>
    );
    const renderHtml = (botao, indice) => {
        if (botao.resourceFilhos.length > 0)
            return renderSubmenu(botao, indice);
        return renderMenu(botao, indice);
    };
    return {
        renderHtml,
    };
};
const Header: FC<{
    handleOpenMenuMobile: (open: boolean) => void;
}> = ({ handleOpenMenuMobile }) => {
    const { data: resultQueryData } = useQuery(
        GRAPHQL_RECUPERAR_RESOURCES_POR_USUARIO,
    );
    const itensMenu =
        resultQueryData && 'recuperarResourcesPorUsuario' in resultQueryData
            ? resultQueryData.recuperarResourcesPorUsuario
            : [];

    return (
        <>
            <WrapHeader>
                <WarpLogoMenu>
                    <WarpLogo>
                        <Logo
                            className="logo-icone"
                            src={logoIcone}
                        />
                        <Logo
                            className="logo-text"
                            src={logoText}
                        />
                    </WarpLogo>
                    <ToggleMenu
                        className="toggle-menu"
                        onClick={() => handleOpenMenuMobile(true)}>
                        <Icone icone="icon-menu-sanduiche" />
                    </ToggleMenu>
                </WarpLogoMenu>
                <SelectUnidadeEUsuario />
            </WrapHeader>
        </>
    );
};
export default Header;
